import React, {useState} from "react";
import TrashIcon from "../../../../assets/images/classes/trash_icon.svg"
import {cloneDeep} from "lodash";

const ClassesTable = ({ data, onDelete, isEditable, onEditChange }) => {

    return (
        <div className="relative w-full min-h-[500px] bg-white rounded-[20px] mb-[150px] max-w-[1044px] border-[1px] border-[#DADADA]"
            style={{ boxShadow: "0 2px 7px 0 rgba(0, 0, 0, 0.10)" }}
        >
            <div className="overflow-hidden mx-[27px] my-[32px] rounded-t-[20px]">
                {/* 삭제 버튼 영역 */}
                <div
                    className={`absolute left-[-50px] top-[96px] flex flex-col gap-[11px] ${
                        isEditable ? "" : "hidden"
                    }`}
                >
                    {data &&
                        data.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => onDelete(index)}
                            >
                                <img src={TrashIcon} alt="Trash Icon" />
                            </button>
                        ))}
                </div>

                <table className="table-auto w-full">
                    <thead className="bg-[#F3F7FF]">
                    <tr>
                        <th className="px-4 py-2 h-[56px] text-[20px] font-[700] text-[#9BA5C2]">
                            클래스 이름
                        </th>
                    </tr>
                    </thead>
                    <tbody className="border-l border-r border-b border-[#E9E9E9]">
                    {data &&
                        data.map((item, index) => (
                            <tr
                                key={index}
                                className={`border-t bg-white`}
                            >
                                <td className="px-4 py-2 flex h-[50px] text-[14px] font-[500] text-[#5E6169] items-center justify-center">
                                    {isEditable ? (
                                        <input
                                            type="text"
                                            value={item.name}
                                            onChange={(e) =>
                                                onEditChange(index, e.target.value, data)
                                            }
                                            className="border rounded px-2 py-1 max-w-full w-[500px] text-center"
                                        />
                                    ) : (
                                        item.name
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ClassesTable;
